import { render, staticRenderFns } from "./ScheduledMessages.vue?vue&type=template&id=5e0972f6&"
import script from "./ScheduledMessages.vue?vue&type=script&lang=js&"
export * from "./ScheduledMessages.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports